import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {DialogService} from 'src/app/services/dialog.service';
import {SessionService} from 'src/app/services/session.service';
import {Constants} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-fad-empresa',
    templateUrl: './fad-empresa.component.html',
    styleUrls: ['./fad-empresa.component.scss']
})
export class FadEmpresaComponent implements AfterViewInit, OnInit {
    private userData: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    countryVisit: any = false;
    contactForm: any;

    constructor(
        private router: Router,
        private sessionService: SessionService,
        private dialogService: DialogService,
        private deviceService: DeviceDetectorService,
        private metas: Meta,
        private titlePage: Title
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        const TITLE = 'Compre um plano de assinatura digital para sua empresa | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'Pacotes e assinaturas a partir de $ 24.90 USD de assinatura digital para sua empresa, o único processo patenteado com 100% de validade legal, comprovado em julgamentos. Integração com qualquer plataforma e sistema.';
        const URL = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-para-empresas';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/empresas.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'firma digital de contratos, realizar firma digital de contratos'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
        /* LOCALIZACION */
        this.sessionService.getLocationUser().subscribe(
            (response: any) => {
                if (response) {
                    this.sessionService.getCountrieUser(response.location.lat, response.location.lng).subscribe(
                        (responseCountrie: any) => {
                            this.sessionService.setCountryData(responseCountrie.results[responseCountrie.results.length - 2]
                                .formatted_address);
                            this.countryVisit = this.sessionService.getCountryData() === 'México';
                        }
                    );
                }
            }
        );
        window.scrollTo(0, 0);
        this.userData = this.sessionService.getPaymentAccount();
    }

    ngOnInit(): void {
        this.addDataLayer();
    }

    ngAfterViewInit(): void {
    }

    addDataLayerEmpresas(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'BRL',
                add: {                                // 'add' actionFieldObject measures.
                    products: [{                        //  adding a product to a shopping cart.
                        name: 'FAD® - Plano Empresarial - Plano Mensal',
                        id: 'FADPESM',
                        price: '149,90',
                        brand: 'FAD®',
                        category: 'FAD® Empresarial',
                        variant: 'Assinaturas Ilimitadas',
                        position: 1
                    }]
                }
            }
        });
    }

    addDataLayerClicProducto(item: any): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: 'Search Results'
                    },
                    products: [{
                        name: item.name,
                        id: item.id,
                        price: item.price,
                        brand: 'FAD®',
                        category: 'FAD® Empresarial',
                        variant: item.variant,
                        position: item.position
                    }]
                }
            }
        });
    }

    callForm(type, isAdd?: boolean): void {
        let data: PaymentData;
        switch (type) {
            case 3:
                data = {
                    product: 'FAD® EMPRESARIAL',
                    subscription: 'Plano mensal',
                    quantity: 1,
                    type: 'month',
                    usuarios: 1,
                    usuariosLabel: 'Usuários incluídos',
                    /* En lugar de mandar el mensaje de ilimitadas, cambie el texto por 1000*/
                    transactions: '1000',
                    transactionType: 'Vídeo de aceitação do acordo + Vídeo assinatura + Constância de conservação',
                    pricing: 149.9,
                    pricingInfo: 'R',
                    complements: [...Constants.defaultComplements]
                };
                if (this.userData === null) {
                    if (isAdd) {
                        this.sessionService.updateCartList(data, true);
                    } else {
                        const itemExist = this.sessionService.getCartItems().find(
                            item => item.product === data.product && item.subscription === data.subscription
                        );
                        if (itemExist) {
                            this.sessionService.setPaymentData(data);
                            this.router.navigate(['/comprar-assinatura-digital']);
                        } else {
                            if (this.sessionService.getCartItems().length === 0) {
                                this.sessionService.updateCartList(data, true);
                                this.sessionService.setPaymentData(data);
                                this.router.navigate(['/comprar-assinatura-digital']);
                            } else {
                                this.dialogService.showNotificationDialog('Ups!', ' Você não pode combinar pacotes.');
                            }
                        }
                    }
                } else {
                    if (this.userData.isCompany === true) {
                        if (isAdd) {
                            this.sessionService.updateCartList(data, true);
                        } else {
                            const itemExist = this.sessionService.getCartItems().find(
                                item => item.product === data.product && item.subscription === data.subscription
                            );
                            if (itemExist) {
                                this.sessionService.setPaymentData(data);
                                this.router.navigate(['/comprar-assinatura-digital']);
                            } else {
                                this.sessionService.updateCartList(data, true);
                                this.sessionService.setPaymentData(data);
                                this.router.navigate(['/comprar-assinatura-digital']);
                            }
                        }
                    } else {
                        this.dialogService.showNotificationDialog('Sua conta é pessoal.', ' Você não pode adicionar este produto, você precisa de uma conta comercial.');
                    }
                }
                this.addDataLayerEmpresas();
                break;
            case 4:
                this.contactForm = 4;
                const prepago = {
                    name: 'FAD® Assinatura - Plano Empresarial - Pré-pagamento por transação com validade anual',
                    id: 'FADPEP',
                    price: '1',
                    variant: 'Pré-pagamento por transação com validade anual',
                    position: '2'
                };
                this.addDataLayerClicProducto(prepago);
                break;
            case 5:
                this.contactForm = 5;
                const integraciones = {
                    name: 'FAD® Assinatura - Plano Empresarial - Integrações especiais',
                    id: 'FADPEIE',
                    price: '1',
                    variant: 'API/SDK',
                    position: '3'
                };
                this.addDataLayerClicProducto(integraciones);
                break;
            case 8:
                this.contactForm =8;
                break;    
        }
        if (this.isMobile === true || this.isTablet === true) {
            document.querySelector('#contact-cotizar-movil').scrollIntoView();
        } else {
            document.querySelector('#contact-cotizar').scrollIntoView();
        }
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'impressionView',
            ecommerce: {
                currencyCode: 'BRL',
                impressions: [
                    {
                        name: 'FAD® Assinatura - Plano Empresarial - Plano Mensal',
                        id: 'FADPESM',
                        price: '149,90',
                        brand: 'FAD®',
                        category: 'FAD® Empresarial',
                        variant: 'Assinaturas Ilimitadas',
                        list: 'FAD® Assinatura - Plano Empresarial',
                        position: 1
                    },
                    {
                        name: 'FAD® Assinatura - Plano Empresarial - Pré-pagamento por transação com validade anual',
                        id: 'FADPEP',
                        price: '1',
                        brand: 'FAD®',
                        category: 'FAD® Empresarial',
                        variant: 'Pré-pagamento por transação com validade anual',
                        list: 'FAD® Assinatura - Plano Empresarial',
                        position: 2
                    },
                    {
                        name: 'FAD® Assinatura - Plano Empresarial - Integrações especiais',
                        id: 'FADPEIE',
                        price: '1',
                        brand: 'FAD®',
                        category: 'FAD® Empresarial',
                        variant: 'API/SDK',
                        list: 'FAD® Assinatura - Plano Empresarial',
                        position: 3
                    }
                ]
            }
        });
    }

}
